import { createContext } from 'react';

export const BrowseDataContext = createContext({});
